module.exports = __webpack_public_path__ + "static/media/nasdaqlogo200.003bbd0d.png";